import React from 'react'
import { connect } from 'react-redux'

import QUOTE_MARK from './quote-mark.svg'
import BOLTS_ICON from 'images/drift-bolts.svg'
import DRIFT_LOGO from '../drift-logo.svg'

import * as BillingSelectors from 'modules/billing/selectors'
import { H3 } from '@drifthq/tide-core'

import './style.css'

const mapStateToProps = (state) => {
  const salesRep = BillingSelectors.getDealRep(state) || {}

  return {
    avatarUrl: salesRep.avatarUrl,
    name: salesRep.fullName,
    title: salesRep.title || 'Conversational Sales Advisor'
  }
}

const SalesRepWelcome = ({ avatarUrl, name, title }) => (
  <div className="sales-rep-welcome">
    <img className="sales-rep-welcome-bolts" src={BOLTS_ICON} alt='Drift bolts'/>
    <div className="sales-rep-welcome--body">
      <div className="sales-rep-welcome--message">
        <div className="sales-rep-welcome--message-body">
          <img className="sales-rep-welcome--quote" src={QUOTE_MARK} alt='quote mark'/>
          <div>
            <span className="sales-rep-welcome--message-body--hello">Hey there!
              <span className="sales-rep-welcome--message-body--hello-2"> So excited to have you onboard with us at Drift <span role="img" aria-label='wave'>👋</span></span>
            </span>
            <div className="sales-rep-welcome--rep">
              <img className="sales-rep-welcome--rep-image" src={avatarUrl || DRIFT_LOGO} alt='This is your sales rep' />
              <div className="sales-rep-welcome--rep-name-title">
                <H3 className="sales-rep-welcome--rep-name">{name}</H3>
                <span className="sales-rep-welcome--rep-title">{title}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default connect(mapStateToProps)(SalesRepWelcome)


// WEBPACK FOOTER //
// ./src/layouts/Deal/SalesRepWelcome/index.js